// import React, { useState, useEffect } from "react";
// import {
//   Input,
//   Button,
//   Form,
//   message as antdMessage,
//   List,
//   Spin,
//   Popover,
//   Tooltip,
// } from "antd";
// import { OpenAI } from "openai";
// import { css } from "@emotion/css";
// import SendIcon from "../../Icons/SendIcon";
//

// const openai = new OpenAI({
//   apiKey: process.env.REACT_APP_OPEN_AI_API_KEY,
//   dangerouslyAllowBrowser: true,
// });

// const ChatComponent = () => {
//   const [form] = Form.useForm();
//   const [loading, setLoading] = useState(false);
//   const [chatLog, setChatLog] = useState(
//     JSON.parse(localStorage.getItem("chatLog")) || [
//       { role: "assistant", content: "Hello! How can I assist you today?" },
//     ]
//   );

//   useEffect(() => {
//     localStorage.setItem("chatLog", JSON.stringify(chatLog));
//   }, [chatLog]);

//   const generateResponse = async () => {
//     try {
//       const prompt = form.getFieldValue("prompt");
//       if (prompt) {
//         if (prompt.split(" ").length > 100) {
//           antdMessage.error("Prompt cannot exceed 100 words.");
//           return;
//         }

//         if (chatLog.filter((item) => item.role === "user").length >= 5) {
//           antdMessage.error("You can only submit up to 5 prompts.");
//           return;
//         }

//         setLoading(true);
//         const updatedChatLog = [...chatLog, { role: "user", content: prompt }];

//         const chatCompletion = await openai.chat.completions.create({
//           messages: updatedChatLog,
//           model: "gpt-3.5-turbo",
//           max_tokens: 150, // Approx. 100 words limit for response
//         });

//         setLoading(false);
//         const response = chatCompletion.choices[0].message.content ?? "";
//         setChatLog([
//           ...updatedChatLog,
//           { role: "assistant", content: response },
//         ]);
//         form.resetFields();
//       } else {
//         antdMessage.error("Prompt cannot be empty.");
//       }
//     } catch (err) {
//       setLoading(false);
//       antdMessage.error("An error occurred while generating the response.");

//     }
//   };

//   return (
//     <div
//       style={{ padding: "20px" }}
//       className={css`
//         .user-div {
//           display: flex;
//           flex-direction: column;
//           align-items: flex-end;
//           width: 100%;
//         }
//         .user-chat {
//           text-align: right;
//           padding: 16px;
//           max-width: 80%;
//           margin-left: auto;
//           padding: 8px;
//           background: rgb(0, 0, 0, 5%);
//           margin-top: 4px;
//           border-radius: 16px;
//         }
//         .ai-chat {
//           background: #f16546c9;
//           border-radius: 16px;
//           padding: 8px;
//           color: white;
//           max-width: 80%;
//         }
//         .ai-div {
//           display: flex;
//           margin-block: 8px;
//           flex-direction: column;
//           align-items: flex-start;
//           gap: 4px;
//           width: 100%;
//         }
//       `}
//     >
//       <Spin
//         spinning={loading}
//         indicator={
//           <CustomLoaderIcon style={{ fontSize: 48, color: themeDefault?.info?.colorPrimary }} spin />
//         }
//       >
//         <div
//           style={{
//             width: "100%",
//             display: "flex",
//             flexDirection: "column",
//             gap: "4px",
//             alignItems: "flex-end",
//           }}
//         >
//           {chatLog.map((item, index) => (
//             <React.Fragment key={index + item.content}>
//               {item.role === "user" && (
//                 <div className="user-div">
//                   <strong>You</strong>
//                   <div className="user-chat">
//                     <p style={{ textAlign: "left" }}>{item.content}</p>
//                   </div>
//                 </div>
//               )}
//               {item.role === "assistant" && (
//                 <div className="ai-div">
//                   <strong>Max</strong>
//                   <p className="ai-chat">{item.content}</p>
//                 </div>
//               )}
//             </React.Fragment>
//           ))}
//         </div>
//       </Spin>
//       <div
//         style={{
//           position: "absolute",
//           left: 0,
//           right: 0,
//           bottom: 0,
//           padding: 16,
//           background: "white",
//         }}
//       >
//         <Form form={form} layout="inline" onFinish={generateResponse}>
//           <Form.Item name="prompt" style={{ flexGrow: 1, marginRight: 0 }}>
//             <Input.TextArea
//               rows={4}
//               style={{
//                 maxHeight: "100px",
//                 overflowY: "auto",
//                 paddingRight: "80px",
//                 resize: "none",
//               }}
//               placeholder="Type your prompt here..."
//               disabled={loading}
//             />
//           </Form.Item>

//           <SendIcon
//             style={{
//               fontSize: "20px",
//               display: "flex",
//               position: "absolute",
//               right: "36px",
//               bottom: "0",
//               alignItems: "center",
//               top: "0",
//               cursor: "pointer",
//             }}
//             onClick={() => {
//               if (!loading) {
//                 if (
//                   chatLog.filter((item) => item.role === "user").length >= 5
//                 ) {
//                   antdMessage.error("Cannot send more than 5 prompts");
//                 } else {
//                   form.submit();
//                 }
//               }
//             }}
//           />
//         </Form>
//       </div>
//       <div style={{ height: "132px" }}></div>
//     </div>
//   );
// };

// export default ChatComponent;

import React, { useState, useEffect } from "react";
import {
  Input,
  Button,
  Form,
  message as antdMessage,
  List,
  Spin,
  Popover,
  Tooltip,
} from "antd";
import { OpenAI } from "openai";
import { css } from "@emotion/css";
import SendIcon from "../../Icons/SendIcon";

import { useSelector } from "react-redux";
import CustomLoaderIcon from "../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon";

const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPEN_AI_API_KEY,
  dangerouslyAllowBrowser: true,
});

const ChatComponent = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [chatLog, setChatLog] = useState(
    JSON.parse(localStorage.getItem("chatLog")) || [
      { response: "Hello! How can I assist you today?" },
    ]
  );

  useEffect(() => {
    localStorage.setItem("chatLog", JSON.stringify(chatLog));
  }, [chatLog]);

  const generateResponse = async () => {
    try {
      const prompt = form.getFieldValue("prompt");
      if (prompt) {
        if (prompt.split(" ").length > 100) {
          antdMessage.error("Prompt cannot exceed 100 words.");
          return;
        }

        if (chatLog.filter((item) => item.prompt).length >= 5) {
          antdMessage.error("You can only submit up to 5 prompts.");
          return;
        }

        setLoading(true);
        const chatCompletion = await openai.chat.completions.create({
          messages: [
            {
              role: "user",
              content: prompt,
            },
          ],
          model: "gpt-3.5-turbo",
          max_tokens: 150, // Approx. 100 words limit for response
        });

        setLoading(false);
        const response = chatCompletion.choices[0].message.content ?? "";
        setChatLog([...chatLog, { prompt, response }]);
        form.resetFields();
      } else {
        antdMessage.error("Prompt cannot be empty.");
      }
    } catch (err) {
      setLoading(false);
      antdMessage.error("An error occurred while generating the response.");
      console.log(err.message);
    }
  };

  const themeDefault = useSelector((state) => state.themeDefault);
  return (
    <div
      style={{ padding: "20px" }}
      className={css`
        .user-div {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          width: 100%;
        }
        .user-chat {
          text-align: right;
          padding: 16px;
          max-width: 80%;
          margin-left: auto;
          padding: 8px;
          background: rgb(0, 0, 0, 5%);
          margin-top: 4px;
          border-radius: 16px;
        }
        .ai-chat {
          background: #f16546c9;
          border-radius: 16px;
          padding: 8px;
          color: white;
          max-width: 80%;
        }
        .ai-div {
          display: flex;
          margin-block: 8px;
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
          width: 100%;
        }
      `}
    >
      <Spin
        spinning={loading}
        indicator={
          <CustomLoaderIcon
            style={{ fontSize: 48, color: themeDefault?.info?.colorPrimary }}
            spin
          />
        }
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            alignItems: "flex-end",
          }}
        >
          {chatLog.map((item, index) => (
            <React.Fragment key={index + (item.prompt || "")}>
              {item.prompt && (
                <div className="user-div">
                  <strong>You</strong>
                  <div className="user-chat">
                    <p style={{ textAlign: "left" }}>{item.prompt}</p>
                  </div>
                </div>
              )}
              {item.response && (
                <div className="ai-div">
                  <strong>Max</strong>
                  <p className="ai-chat">{item.response}</p>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </Spin>
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          padding: 16,
        }}
      >
        <Form form={form} layout="inline" onFinish={generateResponse}>
          <Form.Item name="prompt" style={{ flexGrow: 1, marginRight: 0 }}>
            <Input.TextArea
              rows={4}
              style={{
                maxHeight: "100px",
                minHeight: "45px",
                overflowY: "auto",
                paddingRight: "80px",
                // resize: "none",
              }}
              placeholder="Type your prompt here..."
              disabled={loading}
            />
          </Form.Item>

          <SendIcon
            style={{
              fontSize: "20px",
              display: "flex",
              position: "absolute",
              right: "36px",
              bottom: "0",
              alignItems: "center",
              top: "0",
              cursor: "pointer",
            }}
            onClick={() => {
              if (!loading) {
                if (chatLog.filter((item) => item.prompt).length >= 5) {
                  antdMessage.error("Cannot send more than 5 prompts");
                } else {
                  form.submit();
                }
              }
            }}
          />
        </Form>
      </div>
      <div style={{ height: "132px" }}></div>
    </div>
  );
};

export default ChatComponent;
